"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseContainer = exports.Modal = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_modal_1 = __importDefault(require("react-modal"));
const react_transition_group_1 = require("react-transition-group");
const theme_1 = __importDefault(require("../../styles/theme"));
const __1 = require("..");
const styled_1 = __importDefault(require("../../styles/styled"));
const buttons_1 = require("../buttons");
const Modal = ({ isOpen, className, closeDelayMS = 0, closeOnOverlayClick, closeOnEscape = true, contentStyle, onOpen = () => { }, onClose = () => { }, children, renderOnlyChildren = false, variant = 'info', hideCloseButton, cardProps, overlayColor = 'darkBlueSemiOpaque', mobile, inCall, styleOverride = { overlay: null, content: null, card: null }, }) => {
    const nodeRef = (0, react_1.useRef)(null);
    const transitionStyles = {
        entering: { opacity: 1 },
        entered: { opacity: 1 },
        exiting: { opacity: 0 },
        exited: { opacity: 0 },
    };
    const handleClose = (0, react_1.useCallback)(e => {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        onClose();
    }, [onClose]);
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.Transition, Object.assign({ nodeRef: nodeRef, in: isOpen, timeout: closeDelayMS }, { children: state => {
            return ((0, jsx_runtime_1.jsxs)(react_modal_1.default, Object.assign({ isOpen: isOpen, appElement: document.body, shouldCloseOnEsc: closeOnEscape, shouldCloseOnOverlayClick: closeOnOverlayClick, onRequestClose: onClose, onAfterOpen: onOpen, className: className || '', closeTimeoutMS: closeDelayMS, style: {
                    overlay: Object.assign(Object.assign(Object.assign({}, defaultOverlayStyle), { background: theme_1.default.colors[overlayColor], opacity: transitionStyles[state].opacity, transition: `opacity ${closeDelayMS}ms ease-in-out`, zIndex: inCall ? theme_1.default.layers.inCall.modal : theme_1.default.layers.modal }), styleOverride.overlay),
                    content: Object.assign(Object.assign(Object.assign(Object.assign({}, defaultContentStyle), (contentStyle || {})), { opacity: transitionStyles[state].opacity, transition: `opacity ${closeDelayMS}ms ease-in-out`, zIndex: inCall ? theme_1.default.layers.inCall.modal : theme_1.default.layers.modal }), styleOverride.content),
                } }, { children: [!renderOnlyChildren && ((0, jsx_runtime_1.jsxs)(__1.Card, Object.assign({ decoratorPosition: !cardProps ? 'side' : undefined, variant: !cardProps ? variant : undefined }, cardProps, { style: Object.assign({ padding: '36px', maxWidth: mobile ? '366px' : '', zIndex: inCall ? theme_1.default.layers.inCall.modal : theme_1.default.layers.modal }, styleOverride.card) }, { children: [children, !hideCloseButton && ((0, jsx_runtime_1.jsx)(exports.CloseContainer, Object.assign({ "data-testid": "close-form-button", variant: variant }, { children: (0, jsx_runtime_1.jsx)(buttons_1.IconButton, { iconName: 'CloseIcon', size: "medium", label: "close", onClick: handleClose, background: variant === 'info' ? 'azure' : 'transparent', fill: variant === 'info' ? 'white' : undefined }) })))] }))), renderOnlyChildren && children] })));
        } })));
};
exports.Modal = Modal;
exports.Modal.displayName = 'Modal';
const defaultOverlayStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    overflow: 'auto',
};
const defaultContentStyle = {
    position: 'relative',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: 'transparent',
    border: 'none',
    inset: '0px',
};
exports.CloseContainer = styled_1.default.div(({ variant }) => ({
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    right: variant === 'info' ? '32px' : '12px',
    top: variant === 'info' ? '40px' : '12px',
}));
//# sourceMappingURL=modal.js.map